import { DevicePhoneMobileIcon } from '@heroicons/react/20/solid';
import { SparklesIcon } from '@heroicons/react/24/solid';
import classNames from 'classnames';

export type tBubbleSenderLabelProps = {
  title: string;
  isLeadAgent: boolean;
  /** Sent from the phone: a phone icon before "WhatsApp Web o celular". */
  showPhoneIcon?: boolean;
  /**
   * The label line of the message bubble sizes to its text. The album header
   * keeps the old minimum width that spaces the label from its date.
   */
  fitContent?: boolean;
};

/**
 * The sender line of an outgoing bubble: Lead Agent's chip, or who sent it.
 * Shared by the message bubble and the album bubble (INT-1227).
 */
export default function BubbleSenderLabel(props: tBubbleSenderLabelProps) {
  const { title, isLeadAgent, showPhoneIcon, fitContent } = props;
  const widthClass = fitContent ? null : 'min-w-36';

  if (isLeadAgent) {
    return (
      <div className={classNames('flex items-center gap-1', widthClass)}>
        <span className="inline-flex items-center gap-1 px-2 py-0 rounded-full text-[10px] font-normal text-violet-600 bg-violet-100 border border-white shadow-sm">
          <SparklesIcon className="w-3 h-3" />
          Lead Agent
        </span>
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'BubbleSenderLabel text-xs MessageBubbleV2__accent',
        widthClass,
      )}
    >
      {showPhoneIcon && (
        <DevicePhoneMobileIcon className="BubbleSenderLabel__Icon" aria-hidden="true" />
      )}
      {title}
    </div>
  );
}
